var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{class:_vm.btnClass,attrs:{"size":_vm.size,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();return _vm.$emit('btnClicked')}}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }